import React from 'react';
import BasicAWSConfiguration from './BasicAWSConfiguration';
import AdvancedAWSConfiguration from './AdvancedAWSConfiguration';
import ReconnectCloudAccount from '../ReconnectCloudAccount/ReconnectCloudAccount';
import BasicGCPConfiguration from './BasicGCPConfiguration';
import BasicAzureConfiguration from './BasicAzureConfiguration';
import AdvancedGCPConfiguration from './AdvancedGCPConfiguration';
import AdvancedAzureConfiguration from './AdvancedAzureConfiguration';

const ConfigurationTab = props => {
  const { cloudAccountData, updateData } = props;
  const isAdvancedAcc = cloudAccountData.protectionLevel
    ? cloudAccountData.protectionLevel === 'advanced'
    : false;

  return (
    <div
      style={{
        padding: '20px 14px',
      }}
    >
      {cloudAccountData.provider === 'AWS' &&
        (isAdvancedAcc ? (
          <AdvancedAWSConfiguration {...props} />
        ) : (
          <BasicAWSConfiguration {...props} />
        ))}

      {cloudAccountData.provider === 'GCP' &&
        (isAdvancedAcc ? (
          <AdvancedGCPConfiguration {...props} />
        ) : (
          <BasicGCPConfiguration {...props} />
        ))}

      {cloudAccountData.provider === 'AZURE' &&
        (isAdvancedAcc ? (
          <AdvancedAzureConfiguration {...props} />
        ) : (
          <BasicAzureConfiguration {...props} />
        ))}
    </div>
  );
};

export default ConfigurationTab;
